import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/roles',
  component: Management,
  redirect: '/roles/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/roles/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listRoles
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/roles/ListTable'),
          meta: {
            auth: Auth.listRoles,
            tabName: 'all'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/roles/ListTable'),
          meta: {
            auth: Auth.listRoles,
            tabName: 'enabled'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/roles/ListTable'),
          meta: {
            auth: Auth.listRoles,
            tabName: 'disabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/roles/New'),
      meta: {
        auth: Auth.createRole
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/roles/Edit'),
      meta: {
        auth: Auth.updateRole
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/roles/DetailLayout'),
      meta: {
        auth: Auth.showRole
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/roles/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showRole
          }
        }
      ]
    }
  ]
}
